import { useEffect, useRef, useState } from 'react';
import { useAuth } from '@/app/providers/AuthProvider';
import { useScopedNavigate } from '@/app/providers/TenantScopeProvider';
import type { ScopedRouteKey } from '@/app/routes';

interface MenuItem {
  routeKey: ScopedRouteKey;
  label: string;
  icon: string;
}

const MENU: MenuItem[] = [
  { routeKey: 'profile', label: 'Профайл', icon: 'person' },
  { routeKey: 'companySettings', label: 'Байгууллагын тохиргоо', icon: 'gear' },
  { routeKey: 'terminals', label: 'ПОС терминалууд', icon: 'pc-display-horizontal' },
  { routeKey: 'invoices', label: 'Багцын нэхэмжлэх', icon: 'receipt-cutoff' },
];

export function UserMenu() {
  const { snapshot, logout } = useAuth();
  const navScoped = useScopedNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const avatarText = (snapshot.phone ?? '').slice(-2) || 'МХ';
  const phone = snapshot.phone ?? '';

  useEffect(() => {
    if (!open) return;
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, [open]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button
        type="button"
        className="ts-avatar"
        onClick={() => setOpen((x) => !x)}
        title={phone ? `+976 ${phone}` : 'Профайл'}
        aria-haspopup="menu"
        aria-expanded={open}
        style={{ border: 0, cursor: 'pointer' }}
      >
        {avatarText}
      </button>
      {open ? (
        <div
          role="menu"
          className="ts-card"
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 6px)',
            padding: 6,
            minWidth: 240,
            zIndex: 300,
          }}
        >
          <div
            style={{
              padding: '8px 10px',
              borderBottom: '1px solid var(--ts-border)',
              marginBottom: 6,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: '0.85rem' }}>
              {snapshot.displayName ?? 'Хэрэглэгч'}
            </div>
            <div style={{ fontSize: '0.72rem', color: 'var(--ts-muted)' }}>
              {phone ? `+976 ${phone}` : 'Утас алга'}
            </div>
          </div>
          {MENU.map((m) => (
            <button
              key={m.routeKey}
              type="button"
              role="menuitem"
              className="ts-nav-item"
              style={{ width: '100%', justifyContent: 'flex-start', color: 'var(--bs-body-color)' }}
              onClick={() => {
                navScoped(m.routeKey);
                setOpen(false);
              }}
            >
              <i className={`bi bi-${m.icon}`} />
              <span style={{ flex: 1, textAlign: 'left' }}>{m.label}</span>
            </button>
          ))}
          <div style={{ borderTop: '1px solid var(--ts-border)', margin: '6px 0' }} />
          <button
            type="button"
            role="menuitem"
            className="ts-nav-item"
            style={{
              width: '100%',
              justifyContent: 'flex-start',
              color: '#ef4444',
            }}
            onClick={() => {
              setOpen(false);
              logout();
            }}
          >
            <i className="bi bi-box-arrow-right" />
            <span style={{ flex: 1, textAlign: 'left' }}>Гарах</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
